import React, { useCallback, useEffect } from 'react'

function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: (event: MouseEvent) => void
) {
  useEffect(
    () => {
      const listener = (event: any) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }

        handler(event)
      }

      document.addEventListener('mouseup', listener)
      document.addEventListener('touchstart', listener)

      return () => {
        document.removeEventListener('mouseup', listener)
        document.removeEventListener('touchstart', listener)
      }
    }, // It's worth noting that because passed in handler is a new ... // Add ref and handler to effect dependencies
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  )
}

export function useOnClickOutsideWithPortals(
  ref: HTMLElement | null,
  handler: (event: MouseEvent) => void
) {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      // If border of tide-select is clicked the document body becomes the target
      // because each select menuPortalTarget=document.body
      const bodyIsTarget = event.target === document.body

      if (!ref || !ref.contains(event.target as Node) || bodyIsTarget) {
        // WORKAROUND: The dropdown select portal is outside the
        // context of the popperElement. Close element on clicks
        // outside the popper element and outside the dropdown menus.
        const dropdownPortalEls = document.querySelectorAll('.filterSelect__menu')
        const containsTarget = Array.from(dropdownPortalEls).some(el =>
          el.contains(event.target as Node)
        )
        if (!containsTarget && !bodyIsTarget) {
          handler(event)
        }
      }
    },
    [ref, handler]
  )

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [handleClickOutside])
}

export default useOnClickOutside
